// analytics/AnalyticsFactory.ts
import { AnalyticsProvider } from './AnalyticTypes';
import { PostHogAnalyticsProvider } from './PostHogProvider';

export function createAnalyticsProvider(): AnalyticsProvider | undefined {
  if (process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER === 'posthog') {
    return new PostHogAnalyticsProvider();
  }
  return undefined;
}
